<template>
  <div>
    <hr>
      <div class="mb-3">
        <table class="tablaBusqueda">
          <tr>
            <td>
              <button type="submit" class="btn btn-light" data-bs-toggle="modal" data-bs-target="#ventanaModal" @click="abrirModalCrear" title="Nuevo registro">
                <i class="material-icons" style="font-size:24px;color:green; cursor: pointer;">add_box</i>
              </button>
            </td>
          </tr>
        </table>
      </div>
    <table class="table table-striped" id="sampleTable">
      <thead>
        <tr>
          <th scope="col"></th>
          <th scope="col"></th>
          <th scope="col">Observación</th>
          <th scope="col">FechaReg</th>
          <th scope="col">FechaAct</th>
          <th scope="col">TratamientoObservacion</th>
          <th scope="col"></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="receta in datosPaginados" :key="receta.idReceta">
          <td><i class="material-icons" style="font-size:16px;color:orangered; cursor: pointer;" @click="abrirModalEditar(receta.idReceta)" title="Editar">edit_square</i></td>
          <td><i class="material-icons" style="font-size:16px;color:orangered; cursor: pointer;" @click="abrirEditar(receta.idReceta)" title="Editar">edit_square</i></td>
          <td>{{receta.observacion}}</td>
          <td>{{getFormattedDate(receta.fechaReg, 'DD/MM/YYYY')}}</td>
          <td>{{getFormattedDate(receta.fechaAct, 'DD/MM/YYYY')}}</td>
          <td>{{receta.tratamientoObservacion}}</td>
          <td><i class="material-icons" style="font-size:16px;color:red; cursor: pointer;" @click="deleteReceta(receta.idReceta)" title="Borrar">delete</i></td>
        </tr>
      </tbody>
    </table>
    <nav aria-label="Page navigation example">
      <ul class="pagination">
        <li class="page-item" v-on:click="getPreviousPage()"><a class="page-link" href="#">Anterior</a></li>
        <li id="lugar" v-for="pagina in totalPaginas()" v-bind:key="pagina" v-on:click = "getDataPaginaTodos(pagina)" class="page-item" v-bind:class="isActive(pagina)"><a class="page-link" href="#">{{pagina}}</a></li>
        <li class="page-item" v-on:click="getNextPage()"><a class="page-link" href="#">Siguiente</a></li>
      </ul>
    </nav>
<!-- Modal -->
<div class="modal fade" id="ventanaModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true" v-if="modalWindow">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header bg-primary">
        <h5 class="modal-title" id="exampleModalLabel">
          <i class="fa fa-user-plus"></i> {{titulo}}</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
        </button>
      </div>
      <form>
        <div class="modal-body">
            <div class="mb-3" v-if="btnEditar">
              <div class="row">
                <div class="col-2">
                  <label for="idReceta" class="form-label">IdReceta</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="idReceta" name="idReceta" v-model="datoReceta.idReceta" disabled>
                </div>
              </div>
            </div>
<!-- Botón Lista de Valores  Tratamiento -->
<!--
            <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="idTratamiento" class="form-label"> Tratamiento</label>
                  </div>
                  <div class="col-10">
                    <select class="form-control" id="idTratamiento" name="idTratamiento" v-model="datoReceta.idTratamiento">
                      <option v-for="tratamiento in tratamientos" :value="tratamiento.idTratamiento" :key="tratamiento.idTratamiento">
                        {{ tratamiento.nombre }}
                      </option>
                    </select>
                  </div>
                </div>
            </div>
-->
<!-- Botón Lista de Valores  Tratamiento -->
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="observacion" class="form-label">Observación</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="observacion" name="observacion" v-model="datoReceta.observacion" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="fechaReg" class="form-label">FechaReg</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="fechaReg" name="fechaReg" v-model="datoReceta.fechaReg" disabled>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="fechaAct" class="form-label">FechaAct</label>
                </div>
                <div class="col-10">
                <input type="date" class="form-control" id="fechaAct" name="fechaAct" v-model="datoReceta.fechaAct" required>
                </div>
              </div>
            </div>
          </div>
      </form>
      <div class="modal-footer">
<!--
        <div class="me-auto">
          <button type="button" id="send" class="btn btn-light" data-bs-dismiss="modal" title="Cerrar">
            <i class="material-icons" style="font-size:32px;color:orangered; cursor: pointer;">meeting_room</i>
          </button>
        </div>
-->
        <button type="submit" class="btn btn-light" @click.prevent="guardarReceta" v-if="btnCrear" title="Guardar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">save</i>
        </button>
        <button type="submit" class="btn btn-light" @click.prevent="guardarEditReceta" v-if="btnEditar" title="Actualizar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">update</i>
        </button>
      </div>
    </div>
  </div>
</div>
  </div>
</template>
<script>
import { validarForm } from '@/modules/validacionesForms.js'
import dateFormat from '@/modules/dateFormat.js';

import api from "@/services/api";
import * as $ from 'jquery';
window["$"] = $;
window["jQuery"] = $;
import swal from  'sweetalert'
export default {
  props: {
    p_idTratamiento: {
      type: Number,
      required: true
    }
  },  
  components : {
  },
  data () {
    return {
      recetas : [],
      datoReceta : {},
      nombreBusqueda: '',
      titulo: '',
      btnCrear: false,
      btnEditar: false,
      elementosPorPagina: 10,
      datosPaginados: [],
      paginaActual: 1,
      modalWindow: true,
      tratamientos: [],
      showModalHelp: false,
      estiloImagen: {
        width: "200px",
        height: "200px"
      }
    }
  },
  mounted () {
    this.getDataPaginaTodos(this.paginaActual)
    this.fetchTratamientos()
  },
  methods : {
    getFormattedDate(date) {
      return dateFormat.getFormattedDate(date);
    },
    totalPaginas(){
      return Math.ceil(this.recetas.length / this.elementosPorPagina)
    },
/*
    getDataPagina(noPagina){
      if(this.nombreBusqueda != '') {
        api.get('/vwrecetas/nombre/'+this.nombreBusqueda).then(response=>{
          this.recetas=response.data.reverse();  
          this.paginaActual = noPagina;
          this.datosPaginados = [];
          let ini = (noPagina * this.elementosPorPagina) - this.elementosPorPagina;
          let fin = (noPagina * this.elementosPorPagina);
          this.datosPaginados = this.recetas.slice(ini,fin);
        });
      }
    },
*/    
    getDataPaginaTodos(noPagina){
      api.get('/vwrecetas/idtratamiento/'+this.p_idTratamiento).then(response=>{
      this.recetas=response.data.reverse();  
      this.paginaActual = noPagina;
      this.datosPaginados = [];
      let ini = (noPagina * this.elementosPorPagina) - this.elementosPorPagina;
      let fin = (noPagina * this.elementosPorPagina);
      this.datosPaginados = this.recetas.slice(ini,fin);
       });
    },
    getPreviousPage(){
      if(this.paginaActual > 1){
        this.paginaActual--;
      }
      this.getDataPaginaTodos(this.paginaActual);
    },
    getNextPage(){
      if(this.paginaActual < this.totalPaginas()){
        this.paginaActual++;
      }
      this.getDataPaginaTodos(this.paginaActual);
    },
    isActive(noPagina){
      return noPagina == this.paginaActual ? 'active' : ''
    },
    validarForm(){
      const requiredFields = [
        'observacion'
      ];
      const requiredFieldsText = [
        'observacion'
      ];
      return validarForm(this.datoReceta, requiredFields, requiredFieldsText);
    },
    async guardarReceta(){
      if(this.validarForm() === 1){
        try {
          this.datoReceta.idTratamiento = this.p_idTratamiento;
          await api.post('/recetas', this.datoReceta)
          $('#ventanaModal').modal('hide');
          swal("Correcto!", "Receta creada exitosamente!", "success");
          this.getDataPaginaTodos(this.paginaActual);
        } catch (error) { 
          swal("Error!", "Intentelo de nuevo!", "error");
        }
      }
    },
    async guardarEditReceta(){
      if(this.validarForm() === 1){
        try {
          await api.post('/recetas', this.datoReceta)
          $('#ventanaModal').modal('hide');
          this.getDataPaginaTodos(this.paginaActual);
          swal("Correcto!", "Receta creado(a) exitosamente!", "success");
        } catch (error) {
          swal("Error!", "Intentelo de nuevo!", "error");
          var array = Object.values(error.response.data.errors)
          array.forEach(element => swal(String(element)))
        }
      }
    },
    abrirModalCrear(){
      this.modalWindow = true
      this.datoReceta={}
      this.titulo   = 'Crear Receta'
      this.btnCrear = true
      this.btnEditar= false
    },
    abrirModalEditar(idReceta){
      this.modalWindow = true
      if(idReceta != null){    
           api.get('/vwrecetas/'+idReceta).then(resp=>{
          this.datoReceta = resp.data;
           });
      }
      $('#ventanaModal').modal('show');
      this.titulo   = 'Editar Receta'
      this.btnCrear = false
      this.btnEditar= true
    },
    abrirEditar(idReceta){
      if(idReceta != null){
        this.$router.push('/receta_recetadet/'+idReceta)
      }
    },
    async deleteReceta (idReceta) {
      try{
        await api.delete('/recetas/'+idReceta)
          this.getDataPaginaTodos(this.paginaActual);
      }catch(error){
        alert('No se pudo eliminar')
      }
    },
    fetchTratamientos() {
      fetch('http://localhost:8080/api/v1/tratamientos')
        .then(response => response.json())
        .then(data => {
          this.tratamientos = data;
        })
        .catch(error => {
          console.error('Error fetching tratamientos:', error);
        });
    },
  },
}
</script>
<style src="@/assets/css/listaFiltrada.css" scoped></style>
